// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    order?: any;
    OrderDate?: any;
    RequestedDate?: any;
    ShippingMethod?: any;
    OrderSalesperson?: any;
    Status?: any;
    OrderPo?: any;
    PaymentTerms?: any;
    VatNumber?: any;
    ShippingAddress?: any;
    BillingAddress?: any;
    ShipmentPackages?: any;
    Total?: any;
    Notes?: any;
    SummaryTable?: any;
}

type Props = OwnProps;

export interface OrderDetailsViewStyles {
    orderDetailsViewGridItem?: GridItemProps;
    container?: GridContainerProps;
    orderDetailsHeaderGridItem?: GridItemProps;
    sbInformationStyles?: TypographyPresentationProps;
    orderInformationStyles?: GridItemProps;
    sbInformationGridItem?: GridItemProps;
    orderDetailsLayoutLeftStyles?: GridItemProps;
    orderDetailsLayoutRightStyles?: GridItemProps;
    orderDetailsFullItem?: GridItemProps;
    orderDetailsTotalWrapper?: GridItemProps;
    orderInformationItem?: InjectableCss;
}

export const viewStyles: OrderDetailsViewStyles = {
    orderDetailsViewGridItem: { width: 12 },
    orderInformationStyles: {
        width: [12, 6, 6, 6, 6],
        css: css`
            flex-direction: column;
        `,
    },
    orderInformationItem: {
        css: css`
            ${spacingStyles()}
        `,
    },
    sbInformationStyles: {
        variant: "h2",
        color: "primary",
    },
    sbInformationGridItem: {
        width: [12, 6, 6, 6, 6],
        css: css`
            flex-direction: column;
        `,
    },
    orderDetailsLayoutLeftStyles: {
        width: [12, 12, 8, 8, 8],
    },
    orderDetailsLayoutRightStyles: {
        width: [12, 12, 4, 4, 4],
    },
    orderDetailsFullItem: {
        width: 12,
    },
    orderDetailsTotalWrapper: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
};

const styles = viewStyles;

const OrderView: React.FC<Props> = ({
    order,
    OrderDate,
    RequestedDate,
    ShippingMethod,
    OrderSalesperson,
    Status,
    OrderPo,
    PaymentTerms,
    VatNumber,
    ShippingAddress,
    BillingAddress,
    ShipmentPackages,
    Total,
    Notes,
    SummaryTable,
}) => {
    return (
        <GridItem {...styles.orderDetailsViewGridItem}>
            <GridContainer {...styles.container}>
                <GridItem {...styles.orderDetailsLayoutLeftStyles}>
                    <GridContainer {...styles.container}>
                        <GridItem {...styles.orderDetailsFullItem}>
                            <GridContainer {...styles.container}>
                                <GridItem {...styles.orderDetailsFullItem}>
                                    <Typography {...styles.sbInformationStyles}>
                                        {translate("Order Information")}
                                    </Typography>
                                </GridItem>
                                <GridItem {...styles.orderInformationStyles}>
                                    {OrderDate}
                                    {RequestedDate}
                                    {ShippingMethod}
                                    {OrderSalesperson}
                                </GridItem>
                                <GridItem {...styles.orderInformationStyles}>
                                    {Status}
                                    {OrderPo}
                                    {PaymentTerms}
                                    {VatNumber}
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                        <GridItem {...styles.orderDetailsFullItem}>
                            <GridContainer {...styles.container}>
                                <GridItem {...styles.sbInformationGridItem}>{ShippingAddress}</GridItem>
                                <GridItem {...styles.sbInformationGridItem}>{BillingAddress}</GridItem>
                            </GridContainer>
                        </GridItem>
                        {order?.shipmentPackages && order?.shipmentPackages?.length > 0 && (
                            <GridItem {...styles.orderDetailsFullItem}>
                                <Typography {...styles.sbInformationStyles}>
                                    {translate("Shipment Information")}
                                </Typography>
                                {ShipmentPackages}
                            </GridItem>
                        )}
                    </GridContainer>
                </GridItem>
                <GridItem {...styles.orderDetailsLayoutRightStyles}>
                    <GridContainer {...styles.container}>
                        <GridItem {...styles.orderDetailsTotalWrapper}>
                            {Total}
                            {Notes}
                        </GridItem>
                    </GridContainer>
                </GridItem>
                <GridItem {...styles.orderDetailsFullItem}>{SummaryTable}</GridItem>
            </GridContainer>
        </GridItem>
    );
};

export default OrderView;
